import React, { useEffect, useState } from 'react';
import { Select, MenuItem, Box } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

declare global {
    interface Window {
        google: any;
        googleTranslateElementInit: any;
    }
}

const LanguageSwitcher = () => {
    const [currentLang, setCurrentLang] = useState('EN');

    const initTranslate = () => {
        if (window.google?.translate || document.getElementById('google-translate-script')) return;

        window.googleTranslateElementInit = () => {
            new window.google.translate.TranslateElement({
                pageLanguage: 'en',
                includedLanguages: 'es',
                layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
                autoDisplay: false
            }, 'google_translate_element_hidden');
        };

        const script = document.createElement('script');
        script.id = 'google-translate-script';
        script.type = 'text/javascript';
        script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
        script.async = true;
        document.body.appendChild(script);
    };

    useEffect(() => {
        const match = document.cookie.match(/googtrans=\/en\/es/);
        if (match) {
            setCurrentLang('ES');
            initTranslate();
        } else {
            setCurrentLang('EN');
        }
    }, []);

    const handleLanguageChange = (newLang: string) => {
        const select = document.querySelector('.goog-te-combo') as HTMLSelectElement;
        const host = window.location.hostname;
        const domains = [host, '.' + host];
        if (host.includes('.')) {
            const parts = host.split('.');
            const mainDomain = parts.slice(-2).join('.');
            domains.push(mainDomain, '.' + mainDomain);
        }

        if (newLang === 'EN') {
            const paths = ['/', ''];
            domains.forEach(d => {
                paths.forEach(p => {
                    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${p}; domain=${d}`;
                    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${p}`;
                });
            });
            window.location.reload();
        } else {
            const domain = host.includes('.') ? (host.split('.').length > 2 ? '.' + host.split('.').slice(-2).join('.') : host) : host;
            document.cookie = `googtrans=/en/es; path=/; domain=${domain}`;
            document.cookie = `googtrans=/en/es; path=/`;

            if (select) {
                select.value = 'es';
                select.dispatchEvent(new Event('change'));
                setCurrentLang('ES');
            } else {
                initTranslate();
                window.location.reload();
            }
        }
    };

    return (
        <Box className="notranslate" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LanguageIcon sx={{ fontSize: '1.25rem', color: 'rgba(0,0,0,0.7)' }} />
            <Select
                value={currentLang}
                onChange={(e) => handleLanguageChange(e.target.value as string)}
                size="small"
                sx={{
                    height: '32px',
                    minWidth: '100px',
                    backgroundColor: 'white',
                    fontSize: '0.875rem',
                    fontWeight: 'bold',
                    borderRadius: '4px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0,0,0,0.2)',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'black',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'black',
                    },
                    '& .MuiSelect-select': {
                        py: 0.5,
                    }
                }}
            >
                <MenuItem value="EN">English</MenuItem>
                <MenuItem value="ES">Spanish</MenuItem>
            </Select>
        </Box>
    );
};

export default LanguageSwitcher;
